import { memo, useMemo } from "react";
import SearchSelect from "../../../../GlobalComponents/FormComponents/Dropdowns/SearchSelect";

const NONE = { value: "", label: "— none —" };

/**
 * One position of a fixed tag path: the value is picked from the pairs already
 * filed under that key in riu_keywords, searchable, and a value that has no
 * pair yet can be created from the same list.
 *
 * @param {object} props
 * @param {string} props.value
 * @param {string[]} props.options values already paired with this key
 * @param {boolean} [props.dirty] changed and not yet saved
 * @param {boolean} [props.disabled]
 * @param {string} props.ariaLabel
 * @param {(value: string) => void} props.onChange
 * @param {(value: string) => void} props.onCreate makes the pair, then selects it
 */
function TagValueCell({ value, options, dirty, disabled, ariaLabel, onChange, onCreate }) {
  const choices = useMemo(() => {
    const values = options.includes(value) || !value ? options : [value, ...options];
    return [NONE, ...values.map((option) => ({ value: option, label: option }))];
  }, [options, value]);

  return (
    <div className={dirty ? "kgb-tagvalue kgb-tagvalue--dirty" : "kgb-tagvalue"}>
      <SearchSelect
        multiple={false}
        variant="cell"
        options={choices}
        value={value}
        placeholder="—"
        ariaLabel={ariaLabel}
        disabled={disabled}
        onChange={onChange}
        onCreate={onCreate}
        createLabel="Add pair"
      />
    </div>
  );
}

export default memo(TagValueCell);
